import storage from 'src/utils/storageUtils';
import { getUserFromToken } from 'src/DecodeToken';

export const isSanginiRestrictedUser = (user) => {
  // 1. Check user object in Redux / argument
  if (user) {
    const email = (
      user?.loginInfo?.email ||
      user?.personalInfo?.email ||
      user?.email ||
      ''
    ).toLowerCase();
    const fullName = (
      user?.personalInfo?.fullName ||
      user?.fullName ||
      ''
    ).toLowerCase();
    const id = String(user?.id || user?._id || '');

    if (
      email.includes('sangini') ||
      email.includes('tapan') ||
      fullName.includes('tapan') ||
      id === '6ac1ec6ce417113861552cbe' ||
      id === '6ac4ec6ce417113861552cbe'
    ) {
      return true;
    }
  }

  // 2. Check storage for DOCTORNAME
  const doctorName = String(storage.get('DOCTORNAME') || '').toLowerCase();
  if (doctorName.includes('tapan') || doctorName.includes('sangini')) {
    return true;
  }

  // 3. Check storage for CLINIC_ID
  const clinicId = String(storage.get('CLINIC_ID') || '');
  if (
    clinicId === '6ac1ec6ce417113861552cbf' ||
    clinicId === '6ac4ec6ce417113861552cbf'
  ) {
    return true;
  }

  // 4. Check user ID decoded from token
  const tokenUserId = String(getUserFromToken() || '');
  if (
    tokenUserId === '6ac1ec6ce417113861552cbe' ||
    tokenUserId === '6ac4ec6ce417113861552cbe'
  ) {
    return true;
  }

  // 5. Check current URL path
  if (typeof window !== 'undefined' && window.location) {
    const pathname = window.location.pathname;
    if (
      pathname.includes('6ac1ec6ce417113861552cbe') ||
      pathname.includes('6ac4ec6ce417113861552cbe') ||
      pathname.includes('6ac1ec6ce417113861552cbf') ||
      pathname.includes('6ac4ec6ce417113861552cbf')
    ) {
      return true;
    }
  }

  return false;
};
